import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";
import { services } from "../data";
import { fadeUp, stagger, viewport } from "../motion";

export const Services = ({ onSelect }) => {
  const glow = (event) => {
    const rect = event.currentTarget.getBoundingClientRect();
    event.currentTarget.style.setProperty("--mx", `${event.clientX - rect.left}px`);
    event.currentTarget.style.setProperty("--my", `${event.clientY - rect.top}px`);
  };

  return (
    <section className="section services" id="services" data-testid="services-section">
      <motion.div className="section-head" initial="hidden" whileInView="show" viewport={viewport} variants={stagger}>
        <motion.div variants={fadeUp}>
          <p className="eyebrow"><span className="eyebrow-dot" /> O que fazemos</p>
          <h2>Seu próximo nível<br /><em>começa aqui.</em></h2>
        </motion.div>
        <motion.p variants={fadeUp}>Não entregamos fórmulas prontas. Criamos sistemas de crescimento que fazem sentido para o seu negócio — e para os seus números.</motion.p>
      </motion.div>
      <motion.div className="bento" initial="hidden" whileInView="show" viewport={viewport} variants={stagger}>
        {services.map(({ id, icon: Icon, number, title, text, tag }) => (
          <motion.article key={id} className="card" variants={fadeUp} onMouseMove={glow} onClick={() => onSelect(title)} data-testid={`service-card-${id}`}>
            <div className="card-top"><span className="card-num">{number}</span><span className="card-icon"><Icon size={20} /></span></div>
            <h3>{title}</h3>
            <p>{text}</p>
            <div className="card-foot"><span>{tag}</span><ArrowUpRight size={16} /></div>
          </motion.article>
        ))}
      </motion.div>
    </section>
  );
};
